/**
 * Utility functions for detecting offline status
 * Used to determine if itinerary features should be available
 */

/**
 * Check if the device is online
 */
export function isOnline(): boolean {
  return navigator.onLine;
}

/**
 * Check if Firestore is connected
 * Note: This is a simple check. For more robust detection,
 * you may want to use Firestore's onSnapshot with includeMetadataChanges
 */
export function isFirestoreConnected(): boolean {
  return navigator.onLine;
}

/**
 * Determine if itinerary features should be available
 * Returns true if online and Firestore is connected
 */
export function isItineraryFeatureAvailable(): boolean {
  return isOnline() && isFirestoreConnected();
}

/**
 * Add event listeners for online/offline status changes
 * Returns cleanup function to remove listeners
 */
export function addOnlineStatusListener(
  callback: (isOnline: boolean) => void
): () => void {
  const handleOnline = () => callback(true);
  const handleOffline = () => callback(false);

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  // Return cleanup function
  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
}

